export const Color = {
    WHITE: "white",
    YELLOW: "yellow",
    BLUE: "blue",
    GREEN: "green",
    RED: "red"
}
